import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const SubHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 40px;
  border-bottom: 1px solid #000;
  background-color: #fff;
  font-size: 1.2em;
  position: relative;
  
  @media (max-width: 768px) {
    padding: 6px 16px; /* tighter spacing on mobile */
  }
`;

const NavigationLinks = styled.div`
  display: flex;
  gap: 120px; /* desktop spacing between Staples, Statements and Media */
  align-items: center;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  
  @media (max-width: 768px) {
    gap: 18px; /* three links have to fit between Home and Sort */
  }

  @media (max-width: 480px) {
    gap: 12px;
  }
`;

const Link = styled.a`
  /* Match the header logo font defined in GlobalStyles */
  font-family: 'Catchy Mager', sans-serif; /* Apply Catchy Mager custom font to all links */
  text-decoration: none;
  color: #333;
  font-weight: 400; /* Unified font-weight */
  cursor: pointer;
  transition: color 0.3s ease-in-out;
  text-transform: none; /* Remove uppercase transform */
  letter-spacing: normal; /* Unified letter-spacing */
  font-size: 1.2em; /* Unified font size */

  &:hover {
    color: #543230;
  }

  @media (max-width: 480px) {
    font-size: 0.8em; /* five links across a phone screen */
  }
`;

const RightActions = styled.div`
  display: flex;
  align-items: center;
`;

/* Mobile hamburger removed; keeping component deleted from JSX */

const SubHeader = ({ onSortClick, onMenuToggle }) => {
  const navigate = useNavigate();
  
  const handleNavigation = (path) => {
    navigate(path);
  };
  
  return (
    <SubHeaderContainer>
      <Link href="/" onClick={(e) => { e.preventDefault(); handleNavigation('/'); }}>Home</Link>
      
      <NavigationLinks>
        <Link href="#" onClick={(e) => { e.preventDefault(); handleNavigation('/staples'); }}>Staples</Link>
        <Link href="#" onClick={(e) => { e.preventDefault(); handleNavigation('/statements'); }}>Statements</Link>
        <Link href="#" onClick={(e) => { e.preventDefault(); handleNavigation('/media'); }}>Media</Link>
      </NavigationLinks>
      
      <RightActions>
        <Link href="#" onClick={(e) => { e.preventDefault(); onSortClick(); }}>Sort</Link>
      </RightActions>
    </SubHeaderContainer>
  );
};

export default SubHeader;
